import type { FaireProductEntity } from "../../entity_types/product";

export const p_dwr87fmwmm: FaireProductEntity = {
  token: "p_dwr87fmwmm",
  type: "product",
  name: "Wedding Cake Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c91f75f50520cfc2a84cd391e2592839fe8a110542ac3768ce1cc1a1032368b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37f87cbead5f858fdcbee4eb9520859c63c355d320ed92be541f42bc24d3eca6.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:31.085Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
